import { registerPlugin } from "@capacitor/core"

import type { IDatadogCapacitorPlugin } from "./types"

/** Capacitor plugin that provides platform‑specific Datadog functionality,
 * loading the correct implementation for web, iOS, or Android.
 */
const DatadogCapacitorPlugin = registerPlugin<IDatadogCapacitorPlugin>(
  "NexusPlugin",
  {
    web: () =>
      import("./DatadogCapacitorPluginWeb").then(
        (m) => new m.DatadogCapacitorPluginWeb(),
      ),
    android: () =>
      import("./DatadogCapacitorPluginWeb").then(
        (m) => new m.DatadogCapacitorPluginWeb(),
      ),
  },
)
export default DatadogCapacitorPlugin
